import { lazy } from "react";

const Tests = lazy(() => import(/* webpackChunkName: "Tests" */ "../pagesv2/Tests"));

import {
  IconChat,
  IconJoyspace,
  IconCalendar,
  IconThirdApp,
  IconEBook,
  IconWork,
  IconAppointMeeting,
  IconMail
} from "@/components/icon";
import IndexPage from "@/pagesv2/IndexPage";
import IndexPage2 from "@/pagesv2/IndexPageV2";
import Messages from "@/pagesv2/Messages";
import JoySpacePage from "@/pagesv2/JoySpace";
import CalendarPage from "@/pagesv2/CalendarPage";
import ProjectsPage from "@/pagesv2/ProjectsPage";
import ThirdApp from "@/pagesv2/ThirdApp";
import AddressListPage from "@/pagesv2/AddressList";
import Supervise from "@/pagesv2/Supervise";

import ThirdEmailApp from "@/pagesv2/ThirdEmailApp";
import LinkContainerPage from "@/pagesv2/LinkContainerPage";
import SystemSetting from "@/pagesv2/SystemSetting";
// const ThirdApp = lazy(() => import('@/pagesv2/ThirdApp'));
// const Messages = lazy(() => import('@/pagesv2/Messages'));
// const AddressListPage = lazy(() => import('@/pagesv2/AddressList'));
// const JoySpacePage = lazy(() => import('@/pagesv2/JoySpace'));
// const CalendarPage = lazy(() => import('@/pagesv2/CalendarPage'));
// const ProjectsPage = lazy(() => import('@/pagesv2/ProjectsPage'));

export const thirdAppPath = "/third_apps";
export const homeAppPath = "/homePage";
export const linkContainerPath = "/linkContainer";
export const joyspacePath = "/joyspace";

export default [
  {
    path: "/",
    name: "Index",
    component: IndexPage,
    icon: IconChat
  },
  {
    path: homeAppPath,
    name: "homePage",
    component: IndexPage2,
    icon: IconChat
  },
  {
    path: "/systemSetting",
    name: "systemSetting",
    component: lazy(() => import(/* webpackChunkName: "systemSetting" */ "@/pagesv2/SystemSetting"))
  },
  {
    path: "/messages",
    name: "Messages",
    component: Messages,
    icon: IconChat
  },
  {
    path: "/messages/:sType/:sid",
    name: "聊天",
    component: Messages,
    icon: IconChat
  },
  {
    path: "/joyspace",
    name: "JoySpace",
    component: JoySpacePage, // lazy(() => import(/* webpackChunkName: "JoySpace" */ "@/pagesv2/JoySpace")),
    icon: IconJoyspace,
    exact: false
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: lazy(() => import(/* webpackChunkName: "CalendarPage" */ "@/pagesv2/CalendarPage")),
    icon: IconCalendar
  },
  {
    path: "/projects",
    name: "Projects",
    component: lazy(() => import(/* webpackChunkName: "ProjectsPage" */ "@/pagesv2/ProjectsPage")),
    icon: IconWork
  },
  {
    path: thirdAppPath,
    name: "ThirdApp",
    component: ThirdApp,
    icon: IconThirdApp
  },
  {
    path: "/meeting",
    name: "Meeting",
    component: lazy(() => import(/* webpackChunkName: "ProjectsPage" */ "@/pagesv2/Meeting")),
    icon: IconThirdApp
  },
  {
    path: "/address_list",
    name: "AddressList",
    component: lazy(() => import(/* webpackChunkName: "AddressList" */ "@/pagesv2/AddressList")),
    icon: IconEBook
  },
  {
    path: "/third_email",
    name: "ThirdEmail",
    component: ThirdEmailApp,
    icon: IconMail
  },
  {
    path: "/tests",
    name: "Tests",
    icon: IconChat,
    component: Tests
  },
  {
    path: "/supervise/(.*)?",
    name: "督办",
    component: lazy(() => import(/* webpackChunkName: "Supervise" */ "@/pagesv2/Supervise")),
    icon: IconWork
  },
  {
    path: "/wangPinSys",
    name: "wangP",
    component: lazy(() => import(/* webpackChunkName: "Supervise" */ "@/pagesv2/WangPinS")),
    icon: IconWork
  },
  {
    path: linkContainerPath,
    name: "linkContainer",
    component: LinkContainerPage,
    icon: IconWork
  }
];
